module.exports = __webpack_public_path__ + "static/media/Easy Food Ordering.14fbb5d7.webp";